import { makeStyles } from '@material-ui/core/styles';

import { useDialog } from '@setvi/shared/providers';
import { useRFQStore } from 'pages/auto-rfq/store';
import { WarningTriangleIcon } from '@setvi/shared/components/sicons';
import { FileDetailsDialog } from './file-details-dialog';
import { useRfqFailedBannerStore } from './store';

const FILE_DETAILS_DIALOG = 'rfq-failed-file-details';

const useStyles = makeStyles(() => ({
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    padding: '6px 14px',
    borderRadius: 20,
    border: 'none',
    background: '#FDEBD1',
    color: '#F08B0F',
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1,
    cursor: 'pointer',
    transition: 'background 0.2s',
    '&:hover': {
      background: '#FBE0BC'
    }
  },
  icon: {
    fontSize: 20
  }
}));

/**
 * Header badge shown once the failed-processing banner has been dismissed.
 * Displays the failed-file count and opens the file-details dialog on click
 * (instead of reopening the banner). Rendered in the RFQ page headers; renders
 * nothing unless there's a dismissed failure (driven by RFQStatusBanner via the
 * shared store).
 */
export const RfqFailedBannerBadge = () => {
  const classes = useStyles();
  const { openDialog, closeDialog } = useDialog();
  const hasDismissedFailure = useRfqFailedBannerStore(
    s => s.hasDismissedFailure
  );
  const files = useRFQStore(s => s.files);

  if (!hasDismissedFailure) return null;

  const failedCount = files?.filter(f => f?.status === 'FAILED').length ?? 0;
  const label =
    failedCount === 1
      ? '1 processing issue'
      : `${failedCount || ''} processing issues`.trim();

  const openFileDetails = () =>
    openDialog(
      <FileDetailsDialog onClose={() => closeDialog(FILE_DETAILS_DIALOG)} />,
      { id: FILE_DETAILS_DIALOG }
    );

  return (
    <button
      type="button"
      className={classes.badge}
      aria-label={`${label}. Open file details`}
      onClick={openFileDetails}>
      <WarningTriangleIcon className={classes.icon} />
      {label}
    </button>
  );
};

export default RfqFailedBannerBadge;
